<script>
export default {
    props: {
        data: null,
        rfqId: Number,
    },
    methods: {
        generateReport(id){
            this.$emit('generateReport', id)
        },
        uploadAttachment(actReport){
            this.$emit('uploadAttachment', actReport)
        }
    }
}
</script>
<template>
  <div>
    <template v-for="(x, index) in data" >
        <span v-if="index != 0" :key="`A${x.id}`">, </span>
        <a :key="x.id" class="hover-underline text-white" href="javascript:void(0);" :id="`RFQ${rfqId}-Act${x.id}`">
            {{x.reportType}}
        </a>
        <b-popover
            :key="`B${x.id}`"
            :target="`RFQ${v}-Act${x.id}`"
            triggers="click blur"
            custom-class="p-0 p-custom-class"
            placement="bottom"
        >
            <b-list-group class="w-100 fit">
                <b-list-group-item button action @click="generateReport(x.id)">
                    <i class="bx bx-printer align-middle me-2 font-size-16"></i>
                    <span class="align-middle">Generate Report</span>
                </b-list-group-item>

                <b-list-group-item button action @click="uploadAttachment(x)">
                    <i class="bx bx-paperclip align-middle me-2 font-size-16"></i>
                    <span class="align-middle">Upload Attachment</span>
                </b-list-group-item>
            </b-list-group>
        </b-popover>
    </template>
  </div>
</template>